var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckedCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-B-testing",
    transform: "translate(-509.000000, -1916.000000)",
    fill: "#2EC4B6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-checked-circle-green",
    transform: "translate(509.000000, 1916.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.46,5.88 C12.53,6.23 12.6,6.65 12.6,7 C12.6,10.08 10.08,12.6 7,12.6 C3.92,12.6 1.4,10.08 1.4,7 C1.4,3.92 3.92,1.4 7,1.4 C8.12,1.4 9.24,1.75 10.08,2.31 L11.06,1.33 C9.94,0.49 8.54,0 7,0 C3.15,0 0,3.15 0,7 C0,10.85 3.15,14 7,14 C10.85,14 14,10.85 14,7 C14,6.23 13.86,5.46 13.65,4.76 L12.46,5.88 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.3 10.08 3.01 6.79 3.99 5.81 6.3 8.12 13.51 0.91 14.49 1.89"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 7,
    r: 7
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedCircleGreen);
export default __webpack_public_path__ + "static/media/icon-checked-circle-green.d9823de92f5a3d691c9407ebd1b8fae5.svg";
export { ForwardRef as ReactComponent };